import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * "Update available" toast. The service worker precaches the app shell, so
 * after a deploy users keep seeing the previous version until the new
 * worker takes over — which repeatedly read as "where's the new UI?". With
 * registerType "prompt" we surface the moment instead: one tap activates
 * the fresh worker and reloads.
 */
export function ReloadPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-20 z-50 mx-auto flex w-fit max-w-[92vw] items-center gap-3 rounded-2xl bg-charcoal px-4 py-3 text-sm text-white shadow-lg"
    >
      <span>A new version is available.</span>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className="min-h-[36px] rounded-xl bg-white px-3 font-semibold text-charcoal"
      >
        Refresh
      </button>
    </div>
  );
}
